import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button as BaseButton } from 'ui-base';

const Button = ({
  className,
  secondary,
  children,
  disabled,
  fullwidth,
  adaptive,
  iconOnly,
  loading,
  prefix,
  suffix,
  size,
  color,
  noHover,
  isRound,
  onClick,
  ...rest
}) => (
  <BaseButton
    className={classnames(className, size, {
      secondary,
      primary: !secondary,
      disabled,
      adaptive,
      'icon-only': iconOnly,
      loading,
      [`fullwidth-${fullwidth}`]: fullwidth,
      [`color-${color}`]: color,
      'no-hover': noHover,
      'is-round': isRound,
    })}
    onClick={disabled ? null : onClick}
    {...rest}
  >
    <>
      {prefix && <span className="prefix">{prefix}</span>}
      {iconOnly ? children : <span>{children}</span>}
      {suffix && <span className="suffix">{suffix}</span>}
    </>
  </BaseButton>
);

Button.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'exLarge']),
  disabled: PropTypes.bool,
  secondary: PropTypes.bool,
  adaptive: PropTypes.bool,
  iconOnly: PropTypes.bool,
  loading: PropTypes.bool,
  noHover: PropTypes.bool,
  isRound: PropTypes.bool,
  fullwidth: PropTypes.oneOf(['mobile', 'tablet', 'touch', 'all']),
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  onClick: PropTypes.func,
  color: PropTypes.oneOf(['white', 'success-green', 'success-dark', 'red', 'gold', 'orange', 'messenger-blue', 'purple',
    'pyra-green', 'miami-pink', 'yellow', 'nfl-blue', 'teal', 'grey', 'grey-dark']),
};

Button.defaultProps = {
  className: null,
  size: null,
  disabled: false,
  secondary: false,
  adaptive: false,
  iconOnly: false,
  loading: false,
  fullwidth: null,
  prefix: null,
  suffix: null,
  onClick: null,
  color: null,
  noHover: false,
  isRound: false,
};

export { Button };
